import { Spiner, SpinerPage } from "@components/loaders/spiner";
import { Bills } from "@services/dtos/finance.dto";
import { FinanceService } from "@services/finance.service";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { toRp } from "@utils/helper";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import { FaChevronDown, FaFileInvoiceDollar } from "react-icons/fa";
import { FcFinePrint } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const BillPage = () => {
  const navigate = useNavigate();
  const [limit, setLimit] = useState<string>("10");
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  const { data: bio } = useQuery(
    [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    SchoolService.studentBio
  );
  const nis = bio?.data?.nis ?? "";
  const { data, isLoading } = useQuery(
    [FinanceService.queries.GET_FINANCE_BILLS_PAID_OF, nis],
    () => FinanceService.billsPaidOf({ nis })
  );

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Kewajiban",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ leading: "back", title: "Tagihan" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <>
      <SpinerPage show={isLoading} />
      {data?.data != null && data.data.length > 0 ? (
        <>
          <div className="card card-style">
            <div className="content my-3">
              <div className="tw-text-base tw-font-bold tw-text-black dark:tw-text-white">
                Kewajiban Bulanan
              </div>
              {data.data.filter((item) => item.jenis === "bulanan").length >
              0 ? (
                <div className="list-group list-group-flush">
                  {data.data
                    .filter((item) => item.jenis === "bulanan")
                    .map((item, idx) => (
                      <div
                        key={idx}
                        className="list-group-item tw-bg-inherit d-flex tw-px-0 tw-py-3 tw-border-[rgba(0,0,0,0.05)] dark:tw-border-[rgba(255,255,255,0.05)] tw-cursor-pointer"
                      >
                        <div className="rounded-sm tw-w-8 tw-h-8 d-flex tw-flex-none my-auto bg-magenta-dark">
                          <FaFileInvoiceDollar className="m-auto" size={18} />
                        </div>
                        <div className="tw-grow mx-3 my-auto d-flex flex-column tw-w-[calc(100vw-140px)]">
                          <span className="tw-font-medium tw-text-sm dark:tw-text-white tw-truncate">
                            {item.tagihan}
                          </span>
                          <strong className="tw-font-medium tw-text-[11px] tw-leading-4 tw-text-[#adb5bd] tw-truncate">
                            Total : {toRp(item.nominal ?? 0)}
                            {/* Sisa : {toRp(item.sisabayar ?? 0)} */}
                          </strong>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <div className="tw-p-8 text-center ">
                  <FcFinePrint size={50} />
                  <div>Data tidak ditemukan</div>
                </div>
              )}
            </div>
          </div>

          <div className="card card-style">
            <div className="content my-3">
              <div className="tw-text-base tw-font-bold tw-text-black dark:tw-text-white">
                Kewajiban Sekali
              </div>
              {data.data.filter((item) => item.jenis === "sekali").length >
              0 ? (
                <div className="list-group list-group-flush">
                  {data.data
                    .filter((item) => item.jenis === "sekali")
                    .map((item, idx) => (
                      <div
                        key={idx}
                        className="list-group-item tw-bg-inherit d-flex tw-px-0 tw-py-3 tw-border-[rgba(0,0,0,0.05)] dark:tw-border-[rgba(255,255,255,0.05)] tw-cursor-pointer"
                      >
                        <div className="rounded-sm tw-w-8 tw-h-8 d-flex tw-flex-none my-auto bg-magenta-dark">
                          <FaFileInvoiceDollar className="m-auto" size={18} />
                        </div>
                        <div className="tw-grow mx-3 my-auto d-flex flex-column tw-w-[calc(100vw-140px)]">
                          <span className="tw-font-medium tw-text-sm dark:tw-text-white tw-truncate">
                            {item.tagihan}
                          </span>
                          <strong className="tw-font-medium tw-text-[11px] tw-leading-4 tw-text-[#adb5bd] tw-truncate">
                            Total : {toRp(item.nominal ?? 0)}
                            {/* Sisa : {toRp(item.sisabayar ?? 0)} */}
                          </strong>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <div className="tw-p-8 text-center ">
                  <FcFinePrint size={50} />
                  <div>Data tidak ditemukan</div>
                </div>
              )}
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
